module.exports = __webpack_public_path__ + "static/media/star_yellow.7dc6e5d5.svg";